import { __assign } from "tslib";
import { StyleSheet } from "react-native";
import styles from "../styles/styles";
export default {
  choiceStlyesContainer: __assign({
    marginTop: 10,
    backgroundColor: "white",
    borderRadius: 25,
    padding: 5,
    marginLeft: 10,
    marginRight: 10
  }, styles.shadowStyles),
  choiceStlyesText: {
    marginLeft: 10,
    marginRight: 10,
    color: "#0000FF"
  },
  childrenContainer: {
    flexDirection: "row",
    flexWrap: "wrap"
  },
  left: StyleSheet.create({
    container: {
      flex: 1,
      alignItems: "center"
    },
    wrapper: {
      borderRadius: 15,
      backgroundColor: "#f0f0f0",
      minHeight: 20,
      marginBottom: 20,
      width: '90%',
      justifyContent: "space-around"
    },
    containerToNext: {
      borderBottomLeftRadius: 3
    },
    containerToPrevious: {
      borderTopLeftRadius: 3
    }
  }),
  right: StyleSheet.create({
    container: {
      flex: 1,
      alignItems: "flex-end"
    },
    wrapper: {
      borderRadius: 15,
      backgroundColor: "#0084ff",
      marginRight: 10,
      minHeight: 20,
      justifyContent: "flex-end"
    },
    containerToNext: {
      borderBottomRightRadius: 3
    },
    containerToPrevious: {
      borderTopRightRadius: 3
    }
  })
};